import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';

@Pipe({ name: 'trustedUrl' })
export class SafePipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}
  transform(value: any, args?:any): any {
    if (typeof value === 'undefined' || value === null) {
      return '';
    }
    return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
  }
} 
